import {
  doc,
  getDoc,
  updateDoc,
  Timestamp,
} from 'firebase/firestore';
import { db } from '../firebase/config';
import { Salon } from '../types';

export class SalonService {
  // Get salon by ID
  static async getSalon(salonId: string): Promise<Salon | null> {
    try {
      const docRef = doc(db, 'salons', salonId);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const data = docSnap.data();
        return {
          id: docSnap.id,
          ...data,
          createdAt: data.createdAt.toDate(),
          updatedAt: data.updatedAt.toDate(),
        } as Salon;
      }

      return null;
    } catch (error) {
      console.error('Error getting salon:', error);
      throw new Error('Failed to get salon');
    }
  }

  // Update salon profile
  static async updateSalon(salonId: string, updates: Partial<Omit<Salon, 'id' | 'createdAt'>>): Promise<void> {
    try {
      const salonRef = doc(db, 'salons', salonId);
      await updateDoc(salonRef, {
        ...updates,
        updatedAt: Timestamp.now(),
      });
    } catch (error) {
      console.error('Error updating salon:', error);
      throw new Error('Failed to update salon');
    }
  }
}
